const CloseDrawerReducer = (state = "1" , action) =>{
    switch(action.type){
        case "CLOSE_DRAWER":
        return   action.payload
        default: 
        return state
    }
}
export default CloseDrawerReducer;